module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a3-6-24cb37b7e0830a0b37e07bfee59a6626.jpg";